import React from "react";
import Seo from "~/components/Seo";
import GetStartedLandingPage from "~/features/marketing/HomeRegionLandingPage";

function GetStarted() {
  return (
    <GetStartedLandingPage
      topButtons={[
        {
          to: "/signup/",
          children: "Get Started",
        },
      ]}
    />
  );
}

export function Head() {
  return <Seo title="Get Started" />;
}

export default GetStarted;
